<template>
  <div class="w-full flex">
    <div
      v-if="!tenantPermission('display-auth-image')"
      class="mt-8 md:flex hidden absolute z-0 left-20"
    >
      <symmetral-icon />
    </div>
    <div class="flex w-full justify-center pt-4 lg:pt-0">
      <div
        class="flex justify-center min-w-full max-w-full min-h-screen max-h-screen"
      >
        <div
          v-if="breakpoints.w > 1050 && tenantPermission('display-auth-image')"
          class="min-h-screen w-1/2"
        >
          <app-auth-image class="min-h-screen w-full" />
        </div>
        <div
          class="flex justify-center align-center shadow-sm min-h-screen w-full sm:w-4/5 md:w-1/2 pt-12 md:px-12 px-6 p-1"
          :class="tenantPermission('display-auth-image') ? 'border-2' : ''"
        >
          <div
            class="flex flex-col align-center justify-center h-full w-full lg:w-8/12 xl:7/12"
          >
            <div class="flex -mt-2 justify-between">
              <div @click="signUpStep = '1'" class="text-black cursor-pointer">
                <i v-if="signUpStep === '2'" class="el-icon-back"></i>
              </div>
              <div class="flex items-center">
                <div class="h-2 w-30px rounded-3xl bg-primary"></div>
                <div
                  :class="signUpStep !== '1' ? 'bg-primary' : 'bg-gray-9'"
                  class="h-2 mx-1 w-30px rounded-3xl"
                ></div>
                <div
                  :class="signUpStep === '3' ? 'bg-primary' : 'bg-gray-9'"
                  class="h-2 w-30px rounded-3xl"
                ></div>
              </div>
            </div>
            <span
              v-if="signUpStep === '1' || signUpStep === '2'"
              class="flex text-black-2 justify-center pb-4 font-bold text-2xl mb-3 mt-5"
            >
              <span class="hidden md:block"
                >Create your {{ tenantTitle }} account</span
              >
              <span class="block md:hidden">Create your account</span>
            </span>
            <span
              v-else
              class="flex justify-center text-black-2 py-10 font-bold text-2xl"
              >Thank you for signing up !
            </span>
            <!-- INVITED USER SECTION -->
            <el-form
              v-if="invitedUserInfo"
              @keyup.enter.native="validateForm('invitedUserSignUpForm')"
              label-position="top"
              class=""
              :model="invitedUserSignUpForm"
              ref="invitedUserSignUpForm"
              :rules="rules"
              label-width="80px"
              size="normal"
            >
              <div v-if="signUpStep === '1'">
                <div class="flex items-center justify-center my-4">
                  <hr class="w-1/4 flex-none border-gray-2" />
                  <p
                    class="text-xs md:text-normal font-light flex-none grow mx-1"
                  >
                    Sign up with email
                  </p>
                  <hr class="w-1/4 border-gray-2" />
                </div>
                <div class="grid md:grid-cols-2 gap-x-2 my-1">
                  <el-form-item label="First Name" prop="firstName">
                    <el-input
                      name="firstName"
                      placeholder="Enter first name"
                      v-model="invitedUserSignUpForm.firstName"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Last Name" prop="lastName">
                    <el-input
                      placeholder="Enter last name"
                      v-model="invitedUserSignUpForm.lastName"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="my-1">
                  <el-form-item label="Email">
                    <el-input
                      :disabled="true"
                      v-model="invitedUserInfo.email"
                      placeholder="example@email.com"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="grid md:grid-cols-2 gap-x-3 mt-2 mb-1">
                  <el-form-item
                    class="md:zeroMarginBottom"
                    label="Password"
                    prop="password"
                  >
                    <el-input
                      name="password"
                      placeholder="min. 8 characters"
                      show-password
                      type="password"
                      v-model="invitedUserSignUpForm.password"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    class="zeroMarginBottom"
                    label="Confirm Password"
                    prop="confirmPassword"
                  >
                    <el-input
                      placeholder="Retype Password"
                      type="password"
                      show-password
                      v-model="invitedUserSignUpForm.confirmPassword"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </div>
                <blockquote
                  style="word-break: normal"
                  class="text-xs mb-4 text-gray-10 italic"
                >
                  Use 8 or more characters with a mix of letters, numbers &
                  symbols
                </blockquote>
              </div>

              <!-- Sign UP STEP 2 -->

              <div v-else-if="signUpStep === '2'">
                <el-form-item label="Company Name">
                  <el-input
                    :disabled="true"
                    name="businessName"
                    placeholder="Enter a company name"
                    v-model="invitedUserInfo.businessName"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Company Website">
                  <el-input
                    :disabled="true"
                    name="businessWebsite"
                    placeholder="www.businessWebsite.com"
                    type="url"
                    v-model="invitedUserInfo.businessWebsiteURL"
                  ></el-input>
                </el-form-item>
                <div class="grid grid-cols-3 gap-x-2">
                  <el-form-item label="Phone number" class="col-span-1">
                    <el-select
                      class="text-primary"
                      v-model="invitedUserSignUpForm.countryCode"
                      :placeholder="phoneNumberCode.placeholder"
                    >
                      <el-option
                        v-for="item in supportCountriesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    class="col-span-2 mt-5 md:mt-5"
                    prop="telephone"
                  >
                    <el-input
                      v-model="invitedUserSignUpForm.telephone"
                      placeholder="902 234 5679"
                    ></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item class="my-4">
                    <el-checkbox v-model="isChecked"></el-checkbox>
                    <span class="text-xs lg:text-normal font-light pl-4"
                      >I agree to
                      {{
                        tenantIsTma || tenantIsSymmetral
                          ? `${tenantTitle}'`
                          : `${tenantTitle}'s`
                      }}
                      <span
                        v-if="tenantPermission('display-terms-of-service')"
                        class="text-primary cursor-pointer"
                        @click="showTermsOfService"
                        >Terms Of Service
                        <span class="text-black"> and </span></span
                      >
                      <span
                        class="text-primary cursor-pointer"
                        @click="showPrivacyPolicy"
                        >Privacy Policy
                      </span>
                    </span>
                  </el-form-item>
                </div>
              </div>

              <!-- Sign UP STEP 3 -->
              <div v-else class="flex flex-col items-center pb-8">
                <div>
                  You can now proceed to
                  <span
                    class="text-primary font-bold cursor-pointer"
                    @click="goToLogin"
                    >login
                  </span>
                </div>
              </div>
              <el-button
                :disabled="signUpStep === '2' && !isChecked"
                v-if="signUpStep !== '3'"
                class="bg-primary px-4 lg:py-3.5 rounded-lg mt-5 mb-4 text-white text-xs lg:text-sm w-full font-normal"
                :loading="isLoading"
                @click="validateForm('invitedUserSignUpForm')"
              >
                {{
                  signUpStep === '1'
                    ? 'Next'
                    : signUpStep === '2' && !isLoading
                    ? 'Sign Up'
                    : 'Signing Up...'
                }}</el-button
              >
              <p
                v-if="signUpStep === '1'"
                class="flex justify-center text-sm pb-8 lg:text-normal"
                @click="$router.push({ name: 'login' })"
              >
                Already have an account?
                <span class="text-primary ml-1 cursor-pointer">Sign in</span>
              </p>
            </el-form>

            <!-- REGULAR USER SECTION -->
            <el-form
              v-else
              @keyup.enter.native="validateForm('signUpForm')"
              label-position="top"
              class=""
              :model="signUpForm"
              ref="signUpForm"
              :rules="rules"
              label-width="80px"
              size="normal"
            >
              <div v-if="signUpStep === '1'">
                <div
                  :class="useGoogleOuath ? 'flex' : 'hidden'"
                  @click="getGoogleAuthCode"
                  class="cursor-pointer p-3 justify-center items-center text-sm font-light bg-muted rounded"
                >
                  <span class="mr-2 cursor-pointer"><googleIcon /> </span>
                  Sign up with Google
                </div>
                <div
                  :class="useGoogleOuath ? 'flex' : 'hidden'"
                  class="items-center justify-center my-6"
                >
                  <hr class="w-1/4 flex-none border-gray-2" />
                  <p
                    class="text-xs md:text-normal font-light flex-none grow mx-1"
                  >
                    or sign up with email
                  </p>
                  <hr class="w-1/4 border-gray-2" />
                </div>
                <div class="grid md:grid-cols-2 gap-x-2 my-1">
                  <el-form-item label="First Name" prop="firstName">
                    <el-input
                      name="firstName"
                      placeholder="Enter first name"
                      v-model="signUpForm.firstName"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Last Name" prop="lastName">
                    <el-input
                      placeholder="Enter last name"
                      v-model="signUpForm.lastName"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="my-1">
                  <el-form-item label="Email" prop="email">
                    <el-input
                      testId="email"
                      placeholder="name@example.com"
                      type="email"
                      v-model="signUpForm.email"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="grid md:grid-cols-2 gap-x-3 mt-4 mb-1">
                  <el-form-item
                    class="md:zeroMarginBottom"
                    label="Password"
                    prop="password"
                  >
                    <el-input
                      name="password"
                      placeholder="min. 8 characters"
                      show-password
                      type="password"
                      v-model="signUpForm.password"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    class="zeroMarginBottom"
                    label="Confirm Password"
                    prop="confirmPassword"
                  >
                    <el-input
                      placeholder="Retype Password"
                      type="password"
                      show-password
                      v-model="signUpForm.confirmPassword"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </div>
                <blockquote class="text-xs mb-4 text-gray-10 italic">
                  Use 8 or more characters with a mix of letters, numbers &
                  symbols
                </blockquote>
              </div>

              <!-- Sign UP STEP 2 -->

              <div class="-mt-4" v-else-if="signUpStep === '2'">
                <el-form-item label="Company Type" prop="businessType">
                  <el-select
                    class="w-full font-normal text-red-200"
                    name="businessType"
                    v-model="signUpForm.businessType"
                    placeholder="Select"
                    @change="changeBusinessType"
                  >
                    <el-option
                      v-for="item in businessTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Company Name" prop="businessName">
                  <el-input
                    name="businessName"
                    placeholder="Enter company name"
                    v-model="signUpForm.businessName"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="Company Website" prop="businessWebsite">
                  <el-input
                    name="businessWebsite"
                    placeholder="www.businessWebsite.com"
                    v-model="signUpForm.businessWebsite"
                  ></el-input>
                </el-form-item>
                <div class="grid grid-cols-3 gap-x-2">
                  <el-form-item label="Phone number" class="col-span-1">
                    <el-select
                      class="text-primary"
                      v-model="signUpForm.countryCode"
                      :placeholder="phoneNumberCode.placeholder"
                    >
                      <el-option
                        v-for="item in supportCountriesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    class="col-span-2 mt-5 md:mt-5"
                    prop="telephone"
                  >
                    <el-input
                      v-model="signUpForm.telephone"
                      placeholder="902 234 5679"
                    ></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item class="my-4">
                    <el-checkbox v-model="isChecked"></el-checkbox>
                    <span class="text-xs lg:text-normal font-light pl-4"
                      >I agree to
                      {{
                        tenantIsTma || tenantIsSymmetral
                          ? `${tenantTitle}'`
                          : `${tenantTitle}'s`
                      }}
                      <span
                        v-if="tenantPermission('display-terms-of-service')"
                        class="text-primary cursor-pointer"
                        @click="showTermsOfService"
                        >Terms Of Service
                        <span class="text-black"> and </span></span
                      >
                      <span
                        class="text-primary cursor-pointer"
                        @click="showPrivacyPolicy"
                      >
                        Privacy Policy
                      </span>
                    </span>
                  </el-form-item>
                </div>
              </div>

              <!-- Sign UP STEP 3 -->
              <div v-else class="flex flex-col pb-8">
                <div
                  class="flex flex-col items-start pb-5"
                  v-if="!googleAccessToken"
                >
                  <div class="text-base text-left text-gray-4 w-full pb-2">
                    A verification email has been sent to your email address.
                  </div>
                  <div
                    v-if="!isResendingEmail"
                    class="text-base text-left text-gray-4 pt-2"
                  >
                    <span
                      @click="resendEmailVerification"
                      class="text-base cursor-pointer text-primary"
                      >Click here</span
                    >
                    if you did not receive an email.
                  </div>
                  <div v-else class="text-base text-left text-primary pt-4">
                    <span> Resending email.... </span>
                  </div>
                </div>
                <div
                  :class="!googleAccessToken ? 'mt-28' : 'mt-0'"
                  class="font-bold text-gray-4 flex items-start text-left pb-2 text-sm"
                >
                  Here's what's next:
                </div>
                <div
                  v-if="tenantPermission('display-activation-request')"
                  class="text-gray-4 w-full pb-4"
                >
                  You will be contacted via email by our customer support
                  representative to activate your account, or you click the
                  button below to request an account activation
                </div>
                <div v-else class="text-gray-4 w-full pb-4">
                  Contact your relationship officer or manager for support!
                </div>
                <div
                  :class="!googleAccessToken ? 'mt-0' : 'mt-64'"
                  class="text-sm cursor-pointer flex justify-start p-3.5 border border-primary w-48 rounded-md text-primary font-normal"
                >
                  <div class="flex items-center gap-x-3">
                    <rhythm-icon />
                    <p>
                      <a :href="activationRequestURL" target="_blank"
                        >Request activation</a
                      >
                    </p>
                  </div>
                </div>
              </div>
              <el-button
                :disabled="signUpStep === '2' && !isChecked"
                v-if="signUpStep !== '3'"
                class="bg-primary px-4 lg:py-3.5 rounded-lg mt-5 mb-4 text-white text-xs lg:text-sm w-full font-normal"
                :loading="isLoading"
                @click="validateForm('signUpForm')"
              >
                {{
                  signUpStep === '1'
                    ? 'Next'
                    : signUpStep === '2' && !isLoading
                    ? 'Sign Up'
                    : 'Signing Up...'
                }}</el-button
              >
              <p
                v-if="signUpStep === '1'"
                class="flex justify-center text-sm pb-8 lg:text-normal"
                @click="$router.push('login')"
              >
                Already have an account?
                <span class="text-primary ml-1 cursor-pointer">Sign in</span>
              </p>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <terms-of-service
      v-if="showTermsOfServiceDialog"
      :showDialog="showTermsOfServiceDialog"
      @closeDialog="closeDialog"
    />
    <privacy-policy
      v-if="showPrivacyPolicyDialog"
      :showPrivacyDialog="showPrivacyPolicyDialog"
      @closeDialog="closeDialog"
    />
    <torus-mara-terms-of-service
      v-if="showTorusMaraTermsOfServiceDialog"
      :showDialog="showTorusMaraTermsOfServiceDialog"
      @closeDialog="closeDialog"
    />
    <torus-mara-privacy-policy
      v-if="showTorusMaraPrivacyPolicyDialog"
      :showDialog="showTorusMaraPrivacyPolicyDialog"
      @closeDialog="closeDialog"
    />
    <symmetral-privacy-policy
      v-if="showSymmetralPolicyDialog"
      :showDialog="showSymmetralPolicyDialog"
      @closeDialog="closeDialog"
    />
    <symmetral-terms-of-service
      v-if="showSymmetralTermsDialog"
      :showDialog="showSymmetralTermsDialog"
      @closeDialog="closeDialog"
    />
    <tma-privacy-policy
      v-if="showTmaPrivacyPolicyDialog"
      :showDialog="showTmaPrivacyPolicyDialog"
      @closeDialog="closeDialog"
    />
    <ift-terms-of-service
      v-if="showIftTermsDialog"
      :showDialog="showIftTermsDialog"
      @closeDialog="closeDialog"
    />
    <ift-privacy-policy
      v-if="showIftPrivacyPolicyDialog"
      :showDialog="showIftPrivacyPolicyDialog"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import {
  BUSINESS_TYPES,
  COUNTRY_CODE_OPTIONS,
  URL_REGEX,
  PHONE_NUMBER_REGEX,
  PASSWORD_REGEX
} from '@/utils/constants.js'
import { ValidateInput } from '@/utils/helpers.js'
import tenant from '@/mixins/tenant.js'
import terminal from '@/mixins/terminal.js'

export default {
  name: 'signUp',
  mixins: [tenant, terminal],
  data () {
    var validatePassword = (rule, value, callback) => {
      if (!PASSWORD_REGEX.test(value)) {
        callback(
          new Error(
            'Should contain at least one number, one capital letter and one special character'
          )
        )
      } else {
        callback()
      }
    }
    var validateConfirmPassword = (rule, value, callback) => {
      if (this.invitedUserInfo) {
        if (value === '') {
          callback(new Error('Please input the password again'))
        } else if (value !== this.invitedUserSignUpForm.password) {
          callback(new Error("Password inputs don't match!"))
        } else {
          callback()
        }
      } else {
        if (value === '') {
          callback(new Error('Please input the password again'))
        } else if (value !== this.signUpForm.password) {
          callback(new Error("Password inputs don't match!"))
        } else {
          callback()
        }
      }
    }
    var validateWebsiteUrl = (rule, value, callback) => {
      if (!URL_REGEX.test(value) && this.signUpForm.businessWebsite !== '') {
        callback(new Error('Please enter a valid website url'))
      } else {
        callback()
      }
    }
    var validatePhoneNumber = (rule, value, callback) => {
      if (!PHONE_NUMBER_REGEX.test(value)) {
        callback(new Error('Please enter a valid number'))
      } else {
        callback()
      }
    }
    return {
      businessTypes: BUSINESS_TYPES,
      breakpoints,
      showPrivacyPolicyDialog: false,
      showTorusMaraPrivacyPolicyDialog: false,
      showTermsOfServiceDialog: false,
      showIftTermsDialog: false,
      isResendingEmail: false,
      showIftPrivacyPolicyDialog: false,
      signUpStep: '1',
      showTmaPrivacyPolicyDialog: false,
      showSymmetralPolicyDialog: false,
      showSymmetralTermsDialog: false,
      countryCodeOptions: COUNTRY_CODE_OPTIONS,
      rules: {
        firstName: [
          {
            required: true,
            message: 'Please input first name',
            trigger: 'blur'
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        lastName: [
          {
            required: true,
            message: 'Please input last name',
            trigger: 'blur'
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        businessName: [
          {
            required: true,
            message: "Please input Company's name",
            trigger: 'blur'
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        businessType: [
          {
            required: true,
            message: 'Please input Company type',
            trigger: 'blur'
          }
        ],
        businessWebsite: [
          {
            required: true,
            message: "Please input Company's website",
            trigger: ['blur', 'change']
          },
          { validator: validateWebsiteUrl, trigger: ['blur', 'change'] }
        ],
        telephone: [
          {
            required: true,
            message: 'Please input phone number',
            trigger: ['blur', 'change']
          },
          {
            max: 10,
            message: 'Invalid phone number ',
            trigger: ['blur', 'change']
          },
          { validator: validatePhoneNumber, trigger: ['blur', 'change'] }
        ],
        email: [
          {
            required: true,
            type: 'email',
            message: 'Kindly enter a valid email.',
            trigger: ['blur', 'change']
          }
        ],
        password: [
          {
            required: true,
            message: 'Please input your password',
            trigger: ['blur', 'change']
          },
          {
            min: 8,
            message: 'password must be at least 8 characters long',
            trigger: ['blur', 'change']
          },
          { validator: validatePassword, trigger: ['blur', 'change'] }
        ],
        confirmPassword: [
          {
            validator: validateConfirmPassword,
            trigger: ['blur', 'change'],
            required: true
          }
        ]
      },
      isLoading: false,
      isChecked: false,
      userID: '',
      googleAccessToken: '',
      signUpForm: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        businessName: '',
        businessType: '',
        businessWebsite: '',
        countryCode: '',
        telephone: ''
      },
      invitedUserSignUpForm: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        businessName: '',
        businessType: '',
        businessWebsite: '',
        countryCode: '',
        telephone: '',
        isNewUserInvite: true
      },
      showTorusMaraTermsOfServiceDialog: false
    }
  },
  methods: {
    changeBusinessType () {
      if (
        this.signUpForm.businessType === 'hni' ||
        this.invitedUserSignUpForm.businessType === 'hni'
      ) {
        this.rules.businessName[0].required = false
        this.rules.businessWebsite[0].required = false
      } else if (
        this.signUpForm.businessType === 'sme' ||
        this.invitedUserSignUpForm.businessType === 'sme'
      ) {
        this.rules.businessWebsite[0].required = false
      } else if (
        this.signUpForm.businessType === 'fintech' ||
        this.invitedUserSignUpForm.businessType === 'fintech'
      ) {
        this.rules.businessName[0].required = true
        this.rules.businessWebsite[0].required = true
      }
    },
    goToLogin () {
      this.$router.push({ name: 'login' })
    },
    closeDialog () {
      this.showTermsOfServiceDialog = false
      this.showPrivacyPolicyDialog = false
      this.showTorusMaraTermsOfServiceDialog = false
      this.showTorusMaraPrivacyPolicyDialog = false
      this.showTmaPrivacyPolicyDialog = false
      this.showSymmetralPolicyDialog = false
      this.showSymmetralTermsDialog = false
      this.showIftTermsDialog = false
      this.showIftPrivacyPolicyDialog = false
    },
    async validateForm (signUpForm) {
      this.$refs[signUpForm].validate((valid) => {
        if (valid) {
          if (this.signUpStep === '1') {
            this.signUpStep = '2'
          } else {
            if (this.isChecked) {
              this.register()
            }
            // perform Register Post Request here
          }
        } else {
          this.$notify.error({
            title: 'Incomplete details',
            message: 'Please fill the missing Information',
            position: 'top-right'
          })
        }
      })
    },
    register () {
      this.isLoading = true
      if (this.googleAccessToken) {
        this.registerWithGoogle()
      } else {
        const vm = this
        if (this.invitedUserInfo) {
          this.invitedUserSignUpForm.email = this.invitedUserInfo.email
          this.invitedUserSignUpForm.businessName =
            this.invitedUserInfo.businessName
          this.invitedUserSignUpForm.businessType =
            this.invitedUserInfo.businessType
          this.invitedUserSignUpForm.businessWebsite =
            this.invitedUserInfo.businessWebsiteURL

          this.$store
            .dispatch('auth/register', { ...this.invitedUserSignUpForm })
            .then((response) => {
              this.userID = response.data.data.userID
              this.signUpStep = '3'
            })
            .catch((error) => {
              const err = error.response
                ? error.response.data.error.publicMessage
                : error
              vm.$message({
                showClose: true,
                message: err,
                type: 'error'
              })
            })
            .finally(() => {
              this.isLoading = false
              /* clearing the userInvite details in store after sucessful signup */
              this.$store.dispatch('auth/invitedUserInfo', null)
            })
        } else {
          const payload = {
            ...this.signUpForm,
            countryCode:
              this.signUpForm.countryCode || this.phoneNumberCode.defaultValue
          }
          this.$store
            .dispatch('auth/register', payload)
            .then((response) => {
              this.userID = response.data.data.userID
              this.signUpStep = '3'
            })
            .catch((error) => {
              const err = error.response
                ? error.response.data.error.publicMessage
                : error
              vm.$message({
                showClose: true,
                message: err,
                type: 'error'
              })
            })
            .finally(() => {
              this.isLoading = false
            })
        }
      }
    },
    registerWithGoogle () {
      const vm = this
      const gForm = {
        telephone: this.invitedUserInfo
          ? this.invitedUserSignUpForm.telephone
          : this.signUpForm.telephone,
        businessName: this.invitedUserInfo
          ? this.invitedUserInfo.businessName
          : this.signUpForm.businessName,
        businessType: this.invitedUserInfo
          ? this.invitedUserInfo.businessType
          : this.signUpForm.businessType,
        businessWebsite: this.invitedUserInfo
          ? this.invitedUserInfo.businessWebsiteURL
          : this.signUpForm.businessWebsite,
        countryCode: this.invitedUserInfo
          ? this.invitedUserSignUpForm.countryCode
          : this.signUpForm.countryCode,
        isNewUserInvite: !!this.invitedUserInfo
      }
      this.$store
        .dispatch('auth/googleRegister', {
          ...gForm,
          token: this.googleAccessToken
        })
        .then((response) => {
          this.userID = response.data.data.userID
          this.signUpStep = '3'
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: err,
            type: 'error'
          })
          this.googleAccessToken = ''
          this.signUpStep = '1'
        })
        .finally(() => {
          this.isLoading = false
          /* clearing the userInvite details in store after sucessful signup */
          this.$store.dispatch('auth/invitedUserInfo', null)
        })
    },
    async getGoogleAuthCode () {
      const googleUser = await this.$gAuth.signIn()
      if (
        this.invitedUserInfo &&
        googleUser.getBasicProfile().Iv !== this.invitedUserInfo.email
      ) {
        this.$notify.error({
          title: 'Invalid Email',
          message: 'Kindly use the invitation email to signup',
          position: 'top-right'
        })
        this.signUpStep = '1'
        return
      }
      const currentUser = googleUser.getAuthResponse()
      this.googleAccessToken = currentUser.access_token
      this.signUpStep = '2'
    },
    resendEmailVerification () {
      const vm = this
      this.isResendingEmail = true
      this.$store
        .dispatch('auth/resendVerificationEmail', this.userID)
        .then(() => {
          this.isResendingEmail = false
          this.$swal({
            icon: 'success',
            title: 'Verification Link Resent',
            html: 'Tip: Ensure you type in your correct email address',
            iconColor: 'var(--color-primary)',
            showCloseButton: true
          })
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          this.isResendingEmail = false
          vm.$message({
            showClose: true,
            message: err,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    showTermsOfService () {
      if (this.tenantIsTorus) {
        this.showTorusMaraTermsOfServiceDialog = true
      } else if (this.tenantIsSymmetral) {
        this.showSymmetralTermsDialog = true
      } else if (this.tenantIsIFT) {
        this.showIftTermsDialog = true
      } else {
        this.showTermsOfServiceDialog = true
      }
    },
    showPrivacyPolicy () {
      switch (true) {
        case this.tenantIsTorus:
          this.showTorusMaraPrivacyPolicyDialog = true
          break
        case this.tenantIsTma:
          this.showTmaPrivacyPolicyDialog = true
          break
        case this.tenantIsOval:
          this.showPrivacyPolicyDialog = true
          break
        case this.tenantIsSymmetral:
          this.showSymmetralPolicyDialog = true
          break
        case this.tenantIsIFT:
          this.showIftPrivacyPolicyDialog = true
          break
      }
    }
  },
  components: {
    RhythmIcon: () => import('@/assets/v2/icons/RhythmIcon.vue'),
    GoogleIcon: () => import('@/assets/icons/GoogleIcon.vue'),
    AppAuthImage: () => import('@/assets/images/AppAuthImage.vue'),
    TermsOfService: () => import('@/components/base/TermsOfService.vue'),
    PrivacyPolicy: () => import('@/components/base/PrivacyPolicy.vue'),
    SymmetralIcon: () => import('@/assets/icons/SymmetralLogoIcon.vue'),
    TorusMaraTermsOfService: () =>
      import('@/components/base/TorusMaraTermsOfService.vue'),
    TorusMaraPrivacyPolicy: () =>
      import('@/components/base/TorusMaraPrivacyPolicy.vue'),
    TmaPrivacyPolicy: () => import('@/components/base/TMAPrivacyPolicy.vue'),
    SymmetralPrivacyPolicy: () =>
      import('@/components/base/SymmetralPrivacyPolicy.vue'),
    SymmetralTermsOfService: () =>
      import('@/components/base/SymmetralTermsOfService.vue'),
    IftTermsOfService: () => import('@/components/base/IftTermsOfService.vue'),
    IftPrivacyPolicy: () => import('@/components/base/IftPrivacyPolicy.vue')
  },
  computed: {
    activationRequestURL () {
      return this.tenantIsOval
        ? 'https://ovalfi.atlassian.net/servicedesk/customer/portal/1/group/1/create/18'
        : 'https://torusmara.atlassian.net/servicedesk/customer/portals'
    },
    useGoogleOuath () {
      return process.env.VUE_APP_USE_GOOGLE_OAUTH === 'true'
    },
    invitedUserInfo () {
      if (
        this.$route.params.requestID &&
        this.$route.params.requestID ===
          this.$store.state.auth.invitedUserInfo.requestID
      ) {
        return this.$store.state.auth.invitedUserInfo
      }
      return null
    },
    supportedCountries () {
      return this.$store.state.terminal.supportedCountries
    },
    supportCountriesOptions () {
      return COUNTRY_CODE_OPTIONS.filter((cn) =>
        this.tenantIsIFT ? cn.value === 'GH' : true
      ).filter((country) => {
        return this.$store.state.terminal.supportedCountries.includes(
          country.value
        )
      })
    },
    phoneNumberCode () {
      let placeholder
      let defaultValue
      switch (true) {
        case this.tenantIsIFT:
          placeholder = 'GH +233'
          defaultValue = 'GH'
          break
        default:
          placeholder = 'NG +234'
          defaultValue = 'NG'
      }
      return {
        placeholder,
        defaultValue
      }
    }
  },
  async mounted () {
    if (
      this.$route.params.requestID &&
      this.$route.params.requestID !==
        this.$store.state.auth.invitedUserInfo.requestID
    ) {
      this.$router.push({ name: '404ErrorPage' })
    }
    await this.getSupportedCountries()
  },
  watch: {
    'signUpForm.telephone': function (newValue) {
      const result = newValue.replace(/\D/g, '')
      this.$nextTick(() => {
        this.signUpForm.telephone = result
      })
    },
    deep: true
  }
}
</script>

<style scoped>
>>> .el-card__body {
  padding: 10px;
}

>>> .el-form-item__error {
  padding-top: 2px !important ;
  position: static;
}

>>> .el-select .el-input__inner {
  padding: 0 0 0 12px;
  font-weight: 500;
}
.zeroMarginBottom {
  margin-bottom: 0 !important;
}
>>> .el-select .el-input.is-focus .el-input__inner {
  border-color: #c7c8d2;
}
>>> .el-select .el-input__inner:focus {
  border-color: #c7c8d2;
}
>>> .el-select-dropdown__item,
.selected {
  color: #f4a177;
}

>>> .el-form-item__label,
>>> .el-form-item__content {
  line-height: 12px;
  font-size: 12px;
  font-weight: 600;
}

/* @media only screen and (max-width: 600px) {
>>> .el-form-item__label,
>>> .el-form-item__content {
   font-size: 9px;
  }
} */
>>> .el-checkbox__inner {
  border: 2px solid #c7c8d2;
  width: 20px;
  height: 20px;
}
>>> .el-checkbox__inner::after {
  top: 1px;
  left: 5px;
  width: 5px;
  height: 9px;
}
>>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}
>>> .el-checkbox__inner:hover {
  border-color: var(--color-primary);
}
>>> .el-form--label-top .el-form-item__label {
  padding: 4;
}

>>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: var(--color-primary);
}
>>> .el-input__inner {
  border-radius: 8px;
  border-color: #c7c8d2;
  height: 48px;
}
>>> .el-form-item {
  margin-bottom: 15px;
}
</style>
